import { createAsyncThunk } from "@reduxjs/toolkit";
import { globalAPIDictionary } from "../../core/global/global-country-dictionary";
import axios from "axios";
import { fetchDataSourceHandler } from "../../utils/utils";
import * as Sentry from "@sentry/browser";
import LocalStorageService from "../../core/services/local-storage.service";
const localStorageService = LocalStorageService.getService();

export const getCreditsByPlanHandler = createAsyncThunk("data/getCreditsByPlanHandler", async () => {
  try {
    const { data } = await axios.get(globalAPIDictionary.getUserPlanDetails);
    let intelHeaderDataSource = fetchDataSourceHandler(data.header);
    localStorageService.setUserCreditsDetails(JSON.stringify(data));
    const firstPlan = data?.data?.[0]?.user_active_plan;
    if (firstPlan) {
      localStorageService.setDataToLocalStorage("userCurrentPlan", { user_active_plan: firstPlan });
    }
    return { ...data, ...intelHeaderDataSource };
  } catch (error) {
    Sentry.captureException(error);
  }
});

export const getUserProfileHandler = createAsyncThunk("data/getUserProfileHandler", async (params) => {
  const [profileCompleteResult, intelDetailsResult] = await Promise.allSettled([axios.get(globalAPIDictionary.profileComplete, { params }), axios.get(globalAPIDictionary.profileIntel, { params })]);

  let mergedData = {};
  let hasData = false;

  if (profileCompleteResult.status === "fulfilled") {
    mergedData = { ...mergedData, ...profileCompleteResult.value.data };
    hasData = true;
  } else {
    Sentry.captureException(profileCompleteResult.reason);
  }

  if (intelDetailsResult.status === "fulfilled") {
    mergedData = { ...mergedData, ...intelDetailsResult.value.data };
    hasData = true;
  } else {
    Sentry.captureException(intelDetailsResult.reason);
  }

  if (!hasData) {
    const error = new Error("Failed to fetch user profile data from both services");
    Sentry.captureException(error);
    throw error;
  }

  return mergedData;
});

export const setUserTokenDetailsHandler = (state, action) => {
  state.userToken = JSON.parse(JSON.stringify(action.payload));
};

export const setAppliedSelectAllHandler = (state, action) => {
  state.appliedSelectAll = action.payload;
};

export const setUserDataHandler = (state, action) => {
  state.userData = action.payload;
};

export const setRedirectionIdsArray = (state, action) => {
  state.redirectionIdsArr = [...new Set([...(state?.redirectionIdsArr ?? []), action.payload])];
};
